var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "img-fluid",
    id: "outputsvg",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "none",
      transformOrigin: "50% 50%",
      cursor: "move"
    },
    width: 512,
    height: 512,
    viewBox: "0 0 5120 5120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "l51uQTSHZOEr5FPO1Ufrq1A",
    fill: "rgb(0,0,0)",
    style: {
      transform: "none"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pLklwUZmd",
    d: "M0 4865 l0 -255 385 0 385 0 0 -2305 0 -2305 1790 0 1790 0 0 2305 0 2305 385 0 385 0 0 255 0 255 -2560 0 -2560 0 0 -255z m3080 -770 l0 -515 -520 0 -520 0 0 515 0 515 520 0 520 0 0 -515z m-1280 -1275 l0 -260 -260 0 -260 0 0 260 0 260 260 0 260 0 0 -260z m1020 0 l0 -260 -260 0 -260 0 0 260 0 260 260 0 260 0 0 -260z m1020 0 l0 -260 -260 0 -260 0 0 260 0 260 260 0 260 0 0 -260z m-2040 -1030 l0 -260 -260 0 -260 0 0 260 0 260 260 0 260 0 0 -260z m1020 0 l0 -260 -260 0 -260 0 0 260 0 260 260 0 260 0 0 -260z m1020 0 l0 -260 -260 0 -260 0 0 260 0 260 260 0 260 0 0 -260z m-2040 -1020 l0 -260 -260 0 -260 0 0 260 0 260 260 0 260 0 0 -260z m1020 0 l0 -260 -260 0 -260 0 0 260 0 260 260 0 260 0 0 -260z m1020 0 l0 -260 -260 0 -260 0 0 260 0 260 260 0 260 0 0 -260z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.3fe4a213e5be3c63c96f0e3d25f15b8f.svg";
export { ForwardRef as ReactComponent };